// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1h4CF","requiredAsterisk":"Info_requiredAsterisk__BXc_Z"};